import React from "react";

const checkTabChildData = (data, shouldHaveChildArray) => {
	let isNotEmpty = false;
	if (typeof data === "string" || React.isValidElement(data)) {
		if (data !== "") {
			isNotEmpty = true;
		}
	} else if (Array.isArray(data)) {
		const truthies = [];
		if (shouldHaveChildArray) {
			if (data?.length > 0) {
				isNotEmpty = true;
			}
		} else {
			for (let i = 0; i < data.length; i++) {
				const dtArrObj = Object.keys(data[i]);
				for (const child of dtArrObj) {
					if (
						(Array.isArray(data[i]?.[child]) && data[i]?.[child].length > 0) ||
						(typeof data[i]?.[child] === "string" && data[i]?.[child] !== "")
					) {
						truthies.push(true);
					} else {
						truthies.push(false);
					}
				}
			}
		}
		const count = {};
		for (const truth of truthies) {
			if (count[truth]) {
				count[truth] += 1;
			} else {
				count[truth] = 1;
			}
		}
		if (count.true >= truthies.length / 2) isNotEmpty = true;
	} else if (Object.keys(data).length > 0 && data.constructor === Object) {
		const notEmpty = !Object.values(data).every(x => x === null || x === "");
		if (notEmpty) {
			isNotEmpty = true;
		}
	}
	return isNotEmpty;
};

const validateChildContent = value => {
	let isChecked = false;
	if (value?.description && checkTabChildData(value.description)) {
		isChecked = true;
	}
	if (value?.rooms && checkTabChildData(value.rooms, true)) {
		isChecked = true;
	}
	if (value?.dining && checkTabChildData(value.dining)) {
		isChecked = true;
	}
	if (value?.accordions && checkTabChildData(value.accordions)) {
		isChecked = true;
	}
	if (value?.facilities && checkTabChildData(value.facilities)) {
		isChecked = true;
	}
	if (value?.features && checkTabChildData(value.features)) {
		isChecked = true;
	}
	if (value?.attributes && checkTabChildData(value.attributes)) {
		isChecked = true;
	}
	if (value?.alerts && checkTabChildData(value.alerts, true)) {
		isChecked = true;
	}
	if (value?.collections && checkTabChildData(value.collections, true)) {
		isChecked = true;
	}

	return isChecked;
};

export { validateChildContent };
